import styled from 'styled-components';

export const Container = styled.main`
    min-width: 100%;
    min-height: calc(100vh - 7rem);
    display: flex;
    justify-content: center;
    align-items: center;
`;